import {Menu} from 'antd';
import React, {FC} from 'react';

import {KebabMenu} from 'components/@common/widgets/kebab-menu';
import {useAppSelector} from 'store/config/hooks';
import {selectIsThunkPending} from 'store/slices/loading-state-slice';
import {loadTableReportPageData} from 'store/slices/table-report-slice/table-report-slice-thunks';
import {ITableReportDataRequestParams} from 'store/slices/table-report-slice/table-report-slice-types';

import {dynamicActionResolver} from '../lib/action-resolver';
import {activeConditionResolver} from '../lib/active-condition-resolver';
import {IReportConfigurationAction} from '../model/types';

interface IActionsKebabMenuProps {
    actions: IReportConfigurationAction[];
    selectedTableRows: number[];
    docId: string | null;
    templateCode: string | undefined;
    isAllRowsSelected: boolean;
    pageRequestDto?: Omit<ITableReportDataRequestParams, 'templateCode'| 'docId' | 'lookupType'>;
    handleRefreshReportPage?: () => void;
}

export const ActionsKebabMenu: FC<IActionsKebabMenuProps> = ({
    actions,
    selectedTableRows,
    docId,
    templateCode,
    isAllRowsSelected,
    pageRequestDto,
    handleRefreshReportPage,
}: IActionsKebabMenuProps) => {
    const isLoadingPageData = useAppSelector(s => selectIsThunkPending(s, loadTableReportPageData.typePrefix));

    return (
        <KebabMenu>
            <Menu>
                {actions.map(action => (
                    <Menu.Item
                        key={action?.id}
                        disabled={
                            activeConditionResolver(action.activeCondition, selectedTableRows)
                          || isLoadingPageData
                        }
                    >
                        {dynamicActionResolver({
                            action,
                            selectedTableRows,
                            docId,
                            templateCode,
                            isAllRowsSelected,
                            pageRequestDto,
                            handleRefreshReportPage,
                        })}
                    </Menu.Item>
                ))}
            </Menu>
        </KebabMenu>
    );
};
